var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "legal-notices" } },
    [
      _c(
        "ob1-liens-haut-bas",
        {
          attrs: {
            "button-id": "legal-notices-header",
            "button-label": _vm.title,
            "collapsed-block-id": "legal-notices-text",
            "is-collapsed": false,
            "is-mini": true,
          },
        },
        [
          _c(
            "div",
            { staticClass: "row py-1" },
            _vm._l(_vm.legalNotices, function (legalNotice, index) {
              return _c("div", { key: "legal-notice-" + index }, [
                _c("div", { staticClass: "col-12 pb-1" }, [
                  _c("strong", {
                    domProps: { innerHTML: _vm._s(legalNotice.title) },
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "small p-0",
                    domProps: { innerHTML: _vm._s(legalNotice.text) },
                  }),
                ]),
              ])
            }),
            0
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }